import { render, staticRenderFns } from "./template_management.vue?vue&type=template&id=09d75de0&scoped=true&"
import script from "./template_management.vue?vue&type=script&lang=js&"
export * from "./template_management.vue?vue&type=script&lang=js&"
import style0 from "./template_management.vue?vue&type=style&index=0&id=09d75de0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d75de0",
  null
  
)

export default component.exports